import httpRequestHandler from './http'

export const preRegister = (document, email, username, sponsor, partner) =>
  httpRequestHandler.post('registration/pre-register', document, {
    params: {
      cpf: document,
      email,
      username,
      sponsor,
      partner
    }
  });
